module.exports = __webpack_public_path__ + "static/media/staff_woman.5f9c257c.jpg";